@if (activeTheme(); as theme) {
    <header class="partner-header">
        <!-- Top bar: partner logo + tagline -->
        <div class="partner-header__top-bar" [style.background-color]="theme.header.primaryColor">
            <img class="partner-header__logo" [src]="theme.header.logoPath" [alt]="theme.header.tagline" />
            <span class="partner-header__tagline">{{ theme.header.tagline }}</span>
        </div>

        <!-- Bottom bar: diagnostic title + date -->
        <div class="partner-header__bottom-bar" [style.background-color]="theme.header.secondaryColor">
            <div class="partner-header__title-group">
                <p class="partner-header__title">{{ 'maloupe.diagnostic_result.header_partner' | translate }}</p>
                @if (diagnosticDate()) {
                    <p class="partner-header__date">{{ diagnosticDate() | sentenceCase }}</p>
                }
            </div>
        </div>
    </header>
}
